module.exports = __webpack_public_path__ + "5773fe395214d9a06405886175e6decd.svg";